import React from 'react';

const Faq = () => {
    return (
        <div>
           <h2>Thsi is faq page</h2> 
        </div>
    );
};

export default Faq;